export const calculateStandardDeviation = (questions, answers): number => {
  const questionWeights = questions.map((question, index) => {
    const answerIndex = question.answers.findIndex(
      (onQuestion) => answers[index].risk_tolerance_answer_id.toString() === onQuestion.risk_tolerance_answer_id.toString()
    );

    const weight = answerIndex / (question.answers.length - 1);

    return Math.round(weight * 100);
  });

  const meanWeight = questionWeights.reduce((prevVal, curVal) => prevVal + curVal) / questionWeights.length;

  const squareDiffWeight = questionWeights.map((weight) => (weight - meanWeight) ** 2);

  const sumOfSquareDiff = squareDiffWeight.reduce((prevVal, curVal) => prevVal + curVal);

  const standDeviation = Math.sqrt(sumOfSquareDiff / (questionWeights.length - 1));

  return standDeviation;
};
